/**
 * @author       Rich Searle (Sponge) <richard.searle@wearesponge.com>
 * @copyright    2019 Sponge
 * @description  Phaser 3 Boilerplate
 * @license      UNLICENCED
 */

import "phaser";
import Boot from "./scenes/Boot";
import PasswordRandomiserScene from "./scenes/minigames/PasswordRandomiserScene";
import LockTheDoorScene from "./scenes/minigames/LockTheDoorScene";
import EndlessRunnerScene from "./scenes/EndlessRunnerScene";

import SpongePlugin from "./plugins/global/SpongePlugin";
import TrackingPlugin from "./plugins/global/TrackingPlugin";

//import scss styles
import "../styles/index.scss";
import TapOutScene from "./scenes/minigames/TapOutScene";
import SplashScene from "./scenes/SplashScene";
import CloudCatcherScene from "./scenes/minigames/CloudCatcherScene";
import InfoIntroScene from "./scenes/IntroInfoScene";
import TestScene from "./scenes/TestScene";

// import ScrollerPlugin from "phaser3-rex-plugins/plugins/scroller-plugin.js";

// when the page is loaded, create our game instance (entry point, this is what will change per tech)
window.onload = (): void => {
  // some development options, this console.clear resets a developer console on webpack refresh which I find handy.
  console.clear();

  const config: Phaser.Types.Core.GameConfig = {
    title: "Game", // apart from this
    version: "1.0",
    scale: {
      mode: Phaser.Scale.FIT, // Phaser.Scale.FIT
      parent: "game-container",
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 720,
      height: 1280,

      max: {
        width: 720,
        height: 1280,
      },
    },
    physics: {
      default: "arcade",
      arcade: {
        debug: false,
      },
    },
    fps: {
      min: 30,
      target: 60,
    },

    render: {
      antialias: true,
      roundPixels: true,
    },
    type: Phaser.AUTO,
    width: 720,
    height: 1280,
    scene: [
      new Boot(),
      new SplashScene(),
      new EndlessRunnerScene(),
      new PasswordRandomiserScene(),
      new TapOutScene(),
      new LockTheDoorScene(),
      new CloudCatcherScene(),
      new InfoIntroScene(),
      new TestScene(),
    ], // we are going to use boot as our main controller, then any other states ew require after that.
    plugins: {
      global: [
        { key: "sponge", plugin: SpongePlugin, start: true },
        // {
        //   key: "rexScroller",
        //   plugin: ScrollerPlugin,
        //   start: true,
        // },
      ],
    },
    input: {
      keyboard: true,
      mouse: true,
      touch: true, // you can also look at TouchInputConfig if you want to capture touch event outside of the games canvas.
    },
    backgroundColor: 0x111111,
    dom: {
      createContainer: false
    },
    banner: false,
    
  };

  // before we load the game into the page we are going to setup some items
  // that we are going to need to intergrate a Phaser3 game into various HTML based tech.
  // depending on the tech, we may wish to have these DOM elements in different locations or orders.
  // I'm hoping this is the section we can re-write to embed games into different techs.

  const game = new Phaser.Game(config); // finally launch our game.

  (game.plugins.get("_tracking") as TrackingPlugin).events.on(
    "complete",
    () => {
      console.log("Game Marked as Complete");
    }
  );

  // (game.plugins.get("_tracking") as TrackingPlugin).events.on("fail", () => {

  // });

  // (g.plugins.get("_html") as HTMLPlugin).events.on("popup", ( payload: IPopupEvent ) => {
  //   console.log("launch popup ID", payload.model.id, payload.model.pages);
  //   payload.onComplete();

  // });
};
